import { createRouter, createWebHistory } from 'vue-router'
import Graduates from '../views/Graduates.vue'
import TravelRoutes from '../views/TravelRoutes.vue'
import TravelTopics from '../views/TravelTopics.vue'
import Faculty from '../views/Faculty.vue'
import Personnel from '../views/Personnel.vue'

const routes = [
  { path: '/', redirect: '/graduates' },
  { path: '/graduates', name: 'Graduates', component: Graduates },
  { path: '/travel-routes', name: 'TravelRoutes', component: TravelRoutes },
  { path: '/travel-topics', name: 'TravelTopics', component: TravelTopics },
  { path: '/faculty', name: 'Faculty', component: Faculty },
  { path: '/personnel', name: 'Personnel', component: Personnel }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router